// extracted by mini-css-extract-plugin
export default {"header":"header_header__CCcjo","group":"header_group__Yp9fE","avatar":"header_avatar__TkQUO"};